import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreadcrumbDataService } from '../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service';
import { ITags } from '../models/bucket-item.model';
import { DynamicControlsComponent } from '../../../dynamic-controls/dynamic-controls.component';

@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    imports: [DynamicControlsComponent]
})
export class TagsComponent{
  
  @Input() initialValue:Partial<ITags>[]=[];
  @Input() readOnly: boolean = false;
  @Output() selectedTag:EventEmitter<Partial<ITags>[]> = new EventEmitter<Partial<ITags>[]>();
  private breadcrumbDataService = inject(BreadcrumbDataService);

  readonly bucketInfo = toSignal(this.breadcrumbDataService.getCurrentBreadCrumbItem());

  public selectedTags(tags:Partial<ITags>[]){
    tags = tags.filter(tag => !this.initialValue.some(initTag => JSON.stringify(initTag) === JSON.stringify(tag)))
    this.selectedTag.emit(tags);
  }
}
